<script lang="ts">
	import { onMount } from "svelte";
	import mapboxgl from "mapbox-gl";

	export let accesstoken: string;
	export let styleurl: string;
	export let latitude: number;
	export let longitude: number;
	export let zoom: number;

	let mapElement: HTMLElement;

	onMount(() => {
		mapboxgl.accessToken = accesstoken;
		const map = new mapboxgl.Map({
			container: mapElement,
			style: styleurl,
			center: [longitude, latitude],
			zoom: zoom,
		});

		map.addControl(new mapboxgl.NavigationControl());

		const marker = new mapboxgl.Marker({
				color: "#41A9E2",
			})
			.setLngLat([longitude, latitude])
			.addTo(map);
	});
</script>

<div bind:this={mapElement} />

<style lang="scss">
	:global(.bluc-map__fallback) {
		display: none;
	}

	:global(.bluc-map) {
		position: relative;
		width: 100%;
		padding-bottom: 80%;
	}

	:global(bluc-map) {
		position: absolute;
		top: 0;
		width: 100%;
		height: 100%;
	}

	:global(.mapboxgl-map) {
		height: 100%;
	}
</style>
